/**
 * Pure chart-data transforms shared by chart widgets.
 */

/**
 * Rebase the given numeric keys of a row series to fractional change from
 * each key's first finite value (e.g. 187.4 → 0.0, 206.1 → 0.0998…).
 *
 * - Each key rebases against its own first finite, non-zero value, so series
 *   with different starting dates (sparse index data) still anchor at 0%.
 * - Rows where a key is missing/non-numeric become null for that key.
 * - Input rows are not mutated.
 */
export function rebaseToPercent(
  rows: Array<Record<string, unknown>>,
  keys: string[],
): Array<Record<string, unknown>> {
  const baselines: Record<string, number> = {};
  for (const key of keys) {
    for (const row of rows) {
      const v = row[key];
      if (typeof v === 'number' && Number.isFinite(v) && v !== 0) {
        baselines[key] = v;
        break;
      }
    }
  }
  return rows.map(row => {
    const out: Record<string, unknown> = { ...row };
    for (const key of keys) {
      const v = row[key];
      const base = baselines[key];
      out[key] =
        typeof v === 'number' && Number.isFinite(v) && typeof base === 'number'
          ? v / base - 1
          : null;
    }
    return out;
  });
}
